module.exports = __webpack_public_path__ + "img/8.a8d33aca.jpg";